import React from 'react';
import { useIntl } from 'react-intl';
import Backdrop from '@mui/material/Backdrop';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

const Loading = function Loading({ open, loadingCounter }) {
  const intl = useIntl();
  return (
    <div>
      <Backdrop sx={{ color: 'primary.main', zIndex: 10000 }} open={open}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <CircularProgress color="inherit" />
          <Typography
            variant="subtitle2"
            gutterBottom
            style={{ padding: '8px' }}
            sx={{
              color: "#fff"
            }}
          >
            {`${intl.messages.RUNNING_REQUESTS}: ${loadingCounter}`}
          </Typography>
        </div>
      </Backdrop>
    </div>
  );
};

export default Loading;
